
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/style",
      function () {
        return require("private-next-pages/home/style.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/style"])
      });
    }
  